import { type GridColumns, Grid } from '@retailer-platform/shared-components'
import React, { type FunctionComponent, useMemo } from 'react'
import styled from '@emotion/styled'
import { useDomainMessage, useDomainMessages } from 'domains/collections/utils/domain/intl'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import { LoadingPage } from 'gin-and-tonic/containers/loading-page/LoadingPage'
import { type CatalogProduct, useGetProductListQuery } from 'domains/collections/api'
interface Props {
  productIds: string[]
}

type ProductsDatum = Pick<
  CatalogProduct,
  'id' | 'displayName' | 'primaryImageUrl' | 'classificationInfo'
>

const ProductImage = styled.img({
  borderRadius: 10,
  height: 40,
  width: 40,
})

export const CollectionsRuleViewProducts: FunctionComponent<Props> = ({ productIds }) => {
  const messages = useDomainMessages({
    product:
      'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.table.product',
    productCode:
      'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.table.productCode',
  })

  const columns = useMemo(() => {
    const columns: GridColumns<ProductsDatum> = [
      {
        id: 'image',
        Cell: ({ row }) => <ProductImage src={row.original.primaryImageUrl} />,
        width: 40,
      },
      {
        id: 'name',
        Header: messages.product,
        Cell: ({ row }) => row.original.displayName,
      },
      {
        id: 'productCodes',
        Header: messages.productCode,
        Cell: ({ row }) => row.original.classificationInfo.code,
        width: 100,
      },
    ]

    return columns
  }, [messages])

  const noResults = useDomainMessage('collectionsDomain.noResults')

  const { data, loading, error, refetch } = useGetProductListQuery({
    variables: {
      ids: productIds,
    },
  })

  if (loading) {
    return <LoadingPage />
  }

  if (error) {
    return <ErrorPage action={() => refetch()} />
  }

  return (
    <Grid
      height={350}
      columns={columns}
      data={data?.catalogProducts || []}
      emptyStateMessage={noResults}
    />
  )
}
